export default __webpack_public_path__ + "static/media/543.ef9cacce.png";